import { dayjs, FileImgIcon, UserIcon } from '@umanforge/common';
import { PlActionSearch } from 'interfaces/api_deep_search.interfaces';
import React, { useEffect, useState } from 'react';
import { BaseCardComponent } from '../baseCard.component';
import customParseFormat from 'dayjs/plugin/customParseFormat';

interface PlActionCardProps {
  action: PlActionSearch;
}

const PlActionCardComponent: React.FC<PlActionCardProps> = ( { action } ) => {

  dayjs.extend( customParseFormat );

  const [ fileIcon, setFileIcon ] = useState<JSX.Element>( <></> );

  useEffect( () => {
    setFileIcon(
      <img
        src={ action.actionIcon }
        className='w-full h-full object-cover'
        onError={ () => {
          setFileIcon( <FileImgIcon className='w-full h-full'/> );
        } }
      />
    );
  }, [ action ] );

  return (
    <BaseCardComponent
      id={ String( action.index ) }
      title={ action.actionName }
      breadcrumb={ `${ action.clientName } / ${ action.siteName } / ${ action.sectorName }` }
      application={ action.application }
      firstChildren={
        <div className='flex h-full p-1 pt-3 gap-2'>
          <div className='flex flex-col h-full w-full gap-2 items-start justify-end'>
            <span>{ dayjs( action.taskStartDate ).format( 'L LT' ) }</span>
            <span>{ dayjs( action.taskEndDate ).format( 'L LT' ) }</span>
          </div>
          <div className='flex gap-4 h-full w-full items-end justify-end text-xs text-gray-700'>
            <div className='flex gap-1 items-center'>
              <UserIcon className='w-3.5 h-3.5'/>
              <span> { action.userFullname } </span>
            </div>
          </div>
        </div>
      }
      secondeChildren={
        <div className='flex h-full w-fit p-2 items-start justify-center'>
          <div className='h-14 w-14 rounded-md overflow-hidden'>
            { fileIcon }
          </div>
        </div>
      }
    />
  );
};

export { PlActionCardComponent };